import PhoneArea from "components/PhonePreview/PhoneArea"
import moment from "moment"
import React, { useEffect, useState } from "react"

const Preview = ({
  title = "",
  fontColor,
  bgImage,
  bgColor,
  date,
  hour,
  minute,
  timeType,
}) => {
  const [diff, setDiff] = useState()
  useEffect(() => {
    if (date && hour && minute && timeType) {
      const d = new Date(`${date} ${hour}:${minute} ${timeType}`)
      if (new Date() < d) {
        setDiff(moment(d).diff(new Date()))
      } else {
        setDiff(null)
      }
    }
  }, [date, hour, minute, timeType])

  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div className="col-auto py-1 px-1">
          <i
            className="bx bx-menu font-size-24"
            style={{ cursor: "pointer", color: "gray" }}
          />
        </div>
        <div
          className="my-2"
          style={{ fontSize: "16px", textAlign: "center", color: "white" }}
        >
          {title}
        </div>
        <p
          style={{
            fontSize: "22px",
            textAlign: "center",
            color: "white",
            marginBottom: "0px",
            marginBlockStart: "2em",
          }}
        >
          {diff ? parseInt(diff / (24 * 3600 * 1000)) : 0}
        </p>
        <p
          style={{
            fontSize: "22px",
            textAlign: "center",
            color: "white",
          }}
        >
          days
        </p>
        <p className="mt-4" style={{ color: fontColor, textAlign: "center" }}>
          {diff ? new Date(diff)?.getUTCHours() : 0} hours
        </p>
        <p style={{ color: fontColor, textAlign: "center" }}>
          {diff ? new Date(diff)?.getUTCMinutes() : 0} minutes
        </p>
        <p style={{ color: fontColor, textAlign: "center" }}>
          {diff ? new Date(diff)?.getUTCSeconds() : 0} seconds
        </p>
      </div>
    </PhoneArea>
  )
}

export default Preview
